// used in Lobby\fragments.tsx to render game list in Lobby

import React from "react";

import {
	History,
	RoadmapSmall,
	getTranslatedGameName,
	isBetClosed,
	timeLeftStrToto
} from "@/modules/commonMobile";

import img_bet_closed from "@/assets/img/img_bet_closed.png";

import img_info from "@/assets/img/svg/sidemenu/how_to_play.svg";
import img_lobby_playbutton from "@/assets/img/playbutton.gif";

//Lobby stars
import img_star_dark from "@/assets/img/img_star_dark.svg";
import img_star_lit from "@/assets/img/img_star_lit.svg";

import { assetImg } from "@/modules/moduleImporter";
import { ILanguageType, IGameObjectType, ITimerObjectType, MouseEventVoid } from "@/types/GlobalTypes";
import { getAssetPcode, getBasePcode, getFirstNotEmptyPcode, getGameVariants, getGroupCode, isTotoGame } from "@/modules/gamePcode";

//How to use pcode variants:
//actualPcode: if the main game is available and the variants are more than 1

//firstNotEmptyPcode: total game variants is only 1
//	Example: ["p7b"]

//basePcode: use this just in case the game variants are more than 1 and the first game isn't the main game
//  Example: ["m22b", "m22c"]
//  Expected output: "m22"
interface IProps {
	/**
	 * unique pcode, not the actual pcode
	 */
	pcode: string;
	langdata: ILanguageType;

	games: IGameObjectType;
	timers: ITimerObjectType;

	/**
	 * Hovered game pcode
	 */
	activeHover: string;

	ingroup?: boolean;
	hasGroup?: boolean;

	favouritedGames: string[];

	setLobbyRoadmapFilter: MouseEventVoid;
	activateGameGroup?: MouseEventVoid;
	renderGame: (e: any) => void;
	toggleHowToPlay: (e: any) => void;
	toggleFavourite: (e: any) => void;
	toggleLobbyRoadmap: (e: any) => void;
	toggleLobbyHistory: (e: any) => void;

	mouseEnter: (e: any) => void;
	mouseLeave: (e: any) => void;
}

/**
 * for use in Lobby (game list), not the game renderer
 */
export default class LobbyGame extends React.Component<IProps> {
	glow = false;

	private get firstNotEmptyPcode() {
		const { games, pcode } = this.props;
		return getFirstNotEmptyPcode(games, pcode);
	}

	private get actualPcode() {
		const { games, pcode } = this.props;
		return (games[pcode] ? pcode : this.firstNotEmptyPcode);
	}

	/**
	 * Game data (from games[actualPcode])
	 */
	private get game() {
		return this.props.games[this.actualPcode];
	}

	private get gamePcode() {
		return this.game.pcode;
	}

	private get propPcode() {
		return this.props.pcode;
	}

	get basePcode() {
		return getBasePcode(this.actualPcode)
	}

	get assetPcode() {
		return getAssetPcode(this.actualPcode);
	}



	get timerObj() {
		const { game } = this,
			{ timers } = this.props;

		return game && timers[game.pcode];
	}

	protected roadmapTextFragment() {
		const
			{ game } = this,
			{ langdata } = this.props;

		if (!game.roadmapFilters || game.roadmapFilters.length === 0)
			return null;

		const singleRoadmapFilter = game.roadmapFilters.length === 1;

		return (
			<div className="tip left-button">
				<span className={singleRoadmapFilter ? "roadmap" : ""}>
					{
						//If there is only 1 roadmapFilter
						game.lobbyRoadmap && singleRoadmapFilter
							? (
								game.roadmapText ?
									game.roadmapText[Object.keys(game.roadmapText)[0]] :
									"Loading roadmap text..."
							) : langdata["txt_roadmap"]
					}
				</span>
			</div>
		);
	}

	protected roadmapFilterFragment() {
		const
			{ actualPcode, game } = this,
			{ pcode, setLobbyRoadmapFilter } = this.props,
			{ activeRoadmapFilter, alwaysShowRoadmapText, lobbyRoadmap, roadmapFilters, roadmapText } = game;

		if (!lobbyRoadmap || ["m7", "m19", "m24"].includes(pcode) || roadmapFilters.length === 1)
			return null;

		return (
			<div className="roadmap-options tip">
				{
					roadmapFilters.map((filter, idx) =>
						<div key={"r-o t_" + idx}
							className={activeRoadmapFilter === filter ? "active" : ""}

							{...{
								game: actualPcode,
								filter
							}}

							onClick={setLobbyRoadmapFilter}>
							<div>
								{idx + 1}
							</div>
						</div>
					)
				}

				<span className={alwaysShowRoadmapText ? "active" : ""}>
					{roadmapText ? roadmapText[activeRoadmapFilter] : ""}
				</span>
			</div>
		);
	}

	get historyObject() {
		const { game } = this;

		return (
			game.roadmap
				? game.roadmap.big_road
				: game.history
					? game.history
					: null
		);
	}

	protected bottomIconFragment() {
		const { assetPcode } = this;

		if (assetPcode === "m27")
			return null;

		return assetImg(
			"icons",
			`bottom-${assetPcode}`,
			`icons_${assetPcode}`,
			"bottom"
		);
	}

	protected previewImageFragment() {
		const { assetPcode, propPcode: pcode } = this;

		return assetImg(
			"preview",
			assetPcode,
			`preview${pcode}`,
			"preview"
		);
	}

	protected lobbyHistoryContainerFragment() {
		const
			{ game, historyObject, firstNotEmptyPcode } = this,
			{ langdata, pcode } = this.props;

		return (
			<div className="lobby-history-container">
				{this.roadmapTextFragment()}
				{this.roadmapFilterFragment()}

				{
					// Lobby Roadmap
					// use dragscroll to allow dragging while scrolling
					(
						(game.lobbyRoadmap && !(pcode === "m7" || pcode === "m19")) ||
						game.lobbyHistory
					) ? (
						<div className={"lobby-history-roadmap"}>
							{
								game.lobbyRoadmap &&
									historyObject ?
									<RoadmapSmall
										key={`small-roadmap-${pcode}`}
										pcode={firstNotEmptyPcode}
										langdata={langdata}
										history={historyObject}
										historyBlink={game.historyBlink}
										filter={game.activeRoadmapFilter}

										lobbyDesktop={true}
									/> :
									null
							}

							{
								game.lobbyHistory &&
									historyObject ?
									<History
										key={`history-${pcode}`}
										pcode={firstNotEmptyPcode}
										activeGameCount={0}
										history={historyObject}
										historyBlink={game.historyBlink}
										langdata={langdata}
										lobbyDesktop={true}
									/> :
									null
							}
						</div>) : null
				}
			</div>
		)
	}

	protected threeDAnimationFragment() {
		const
			{ activateGameOptions, propPcode: pcode, assetPcode } = this,
			{ activeHover } = this.props;

		return (
			// 3D animation on hover, still 3D image on mouse leave
			<div className="animation" {...activateGameOptions}>
				{
					pcode === "m50"
						? (
							activeHover === pcode
								? assetImg(
									"3d",
									`anim-m50.gif`,
									`3d_anim_m50`,
									"game-3d anim"
								)
								: assetImg(
									"3d",
									`m50`,
									`3d_anim_m50`,
									"game-3d"
								)
						) :
						activeHover === pcode
							? assetImg(
								"3d",
								`anim-${assetPcode}.gif`,
								`3d_anim_${assetPcode}`,
								"game-3d anim"
							)
							: assetImg(
								"3d",
								`${assetPcode}`,
								`3d_anim_${assetPcode}`,
								"game-3d"
							)
				}
			</div>
		);
	}

	protected newGameBadgeFragment() {
		const { game } = this,
			isNewGame = game.newgame === "1";

		if (!isNewGame)
			return null;

		return (
			<span className="game-new">
				NEW
			</span>
		);
	}

	/**
	 * Used in 3D animation, description box (includes game name and timer)
	 */
	get activateGameOptions() {
		const
			{ actualPcode } = this,
			{ ingroup, hasGroup, pcode } = this.props;

		return ({
			group: pcode,
			game: actualPcode,
			onClick: !ingroup && hasGroup
				? this.props.activateGameGroup
				: this.props.renderGame
		});
	}

	private timeLeftFragment() {
		if (!this.timerObj)
			return null;

		const
			{ game, timerObj } = this,
			timeLeft = timerObj ? timerObj.time : 0,
			betClosed = isBetClosed(timeLeft);

		const totoGame = isTotoGame(game.pcode);

		return (
			totoGame
				? (
					<div className="time-left-v5">
						{
							betClosed
								? (
									<div className="bet-close">
										BET CLOSED
									</div>
								) : (
									<div>
										{timeLeftStrToto(timeLeft)}
									</div>
								)
						}
					</div>
				) : (
					<div className="time-left">
						{
							betClosed ?
								<img src={img_bet_closed} alt="bet closed" /> :
								<div>{timeLeft}</div>
						}
					</div>
				)
		);
	}

	/**
	 * Game name & time left container
	 */
	private descFragment() {
		const
			{ activateGameOptions, assetPcode, basePcode, firstNotEmptyPcode, propPcode } = this,
			{ games, hasGroup, ingroup, langdata } = this.props,
			gameVariants = getGameVariants(games, basePcode);

		return (
			<div className="desc" {...activateGameOptions}>
				{assetImg("game_icon", assetPcode + "_wh.svg")}

				<div className="game-name">
					{
						// Use plain game name when not in group
						ingroup
							? getTranslatedGameName(langdata, propPcode, ingroup)
							: (
								gameVariants.length > 1 ?
									getTranslatedGameName(langdata, basePcode) :
									getTranslatedGameName(langdata, firstNotEmptyPcode, false, hasGroup)
							)
					}
				</div>

				{this.timeLeftFragment()}
			</div>
		);
	}

	protected howToPlayButtonFragment() {
		const
			{ propPcode: pcode } = this,
			{ langdata, toggleHowToPlay } = this.props;

		return (
			<div className="how-to-play"
				{...{ game: pcode }}
				onClick={toggleHowToPlay}>

				<div className="tip">
					<img src={img_info} alt="How to play" />

					<span className="lobby-tooltip">
						{langdata["txt_how_to_play"]}
					</span>
				</div>
			</div>
		);
	}

	protected playButtonFragment() {
		const { activeHover, pcode } = this.props;

		if (activeHover !== pcode)
			return null;

		const
			{ actualPcode } = this,
			{ activateGameGroup, langdata, ingroup, hasGroup, renderGame } = this.props,
			group = getGroupCode(pcode);

		return (
			!ingroup && hasGroup ? (
				// Game Group
				<div className="lobby-play-button-overlay"
					{...{ group }}
					onClick={activateGameGroup}>

					<img src={img_lobby_playbutton} alt="Lobby" />
					<div>LOBBY</div>
				</div>
			) : (
				// Play now
				<div className="lobby-play-button-overlay"
					{...{ game: actualPcode }}
					onClick={renderGame}>

					<img src={img_lobby_playbutton} alt="Play Now" />
					<div>
						{langdata["txt_play_now"]}
					</div>
				</div>
			)
		)
	}

	private get isFaved() {
		return this.props.favouritedGames.includes(
			this.basePcode
		);
	}

	protected favBoxFragment() {
		const
			{ isFaved, propPcode: pcode } = this,
			{ toggleFavourite } = this.props;

		return (
			<div className="fav-box"
				{...{ pcode }}
				onClick={toggleFavourite}>
				{
					isFaved ?
						<img src={img_star_lit} alt="is fav" /> :
						<img src={img_star_dark} alt="not fav" />
				}
			</div>
		);
	}

	render() {
		if (!this.game) return null;

		const
			{
				actualPcode,
				assetPcode,
				game,
				propPcode: pcode,
				timerObj
			} = this,
			{ mouseLeave, mouseEnter } = this.props;

		if (actualPcode === "m50")
			console.log("assetPcode for m50: " + assetPcode);

		if (!timerObj)
			console.warn(`timerObj for ${game.pcode} is empty!`);

		return (
			<div className={"lobby-game-preview" + (this.glow ? " glow" : "")}
				{...{ pcode }}
				onMouseLeave={mouseLeave}
				onMouseEnter={mouseEnter}>

				{this.lobbyHistoryContainerFragment()}
				{this.bottomIconFragment()}
				{this.previewImageFragment()}
				{this.threeDAnimationFragment()}
				{this.newGameBadgeFragment()}
				{this.descFragment()}
				{this.howToPlayButtonFragment()}
				{this.playButtonFragment()}
				{this.favBoxFragment()}
			</div>
		);
	}
}

